import { motion } from "framer-motion";
import { ParallaxImage } from "./ParallaxImage";
import { EASE } from "./Reveal";

export default function EditorialBreak({ image, headline, line, eyebrow, testid = "editorial-break", align = "left", position = "center" }) {
  const alignCls = align === "center" ? "items-center text-center" : align === "right" ? "items-end text-right" : "items-start text-left";
  return (
    <section data-testid={testid} className="relative isolate h-[85svh] min-h-[560px] sm:h-[100svh] flex overflow-hidden">
      <ParallaxImage src={image} alt={headline} className="absolute inset-0 -z-10" strength={8} position={position} />
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-[#080808] via-[#080808]/30 to-[#080808]/30" />
      <div className={`max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 mt-auto flex flex-col ${alignCls}`}>
        {eyebrow && (
          <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-10%" }} transition={{ duration: 0.9, ease: EASE }} className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.3em] text-[#C8A86B]">{eyebrow}</motion.p>
        )}
        <motion.h2 initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-10%" }} transition={{ duration: 1.1, delay: 0.1, ease: EASE }} className="mt-5 max-w-4xl font-serif font-light tracking-tight leading-[1.02] text-[#F3EFE6] text-4xl sm:text-5xl lg:text-7xl">
          {headline}
        </motion.h2>
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-10%" }} transition={{ duration: 1, delay: 0.3, ease: EASE }} className="mt-6 max-w-lg text-sm sm:text-base font-light leading-relaxed text-[#D6D1C6]">
          {line}
        </motion.p>
      </div>
    </section>
  );
}
